import { Injectable } from "@angular/core";
import { EmitterAction, Receiver } from "@ngxs-labs/emitter";
import { State, StateContext } from "@ngxs/store";
import { LeadSearchFilter } from "src/app/@models/leads/lead-filter.model";
@State<LeadSearchFilter>({
    name: 'newLeadAdvancedSearch',
    defaults: new LeadSearchFilter()
})
@Injectable({
    providedIn: 'root'
})
export class LeadFilterState {

    @Receiver()
    static setCurrentState(
        { setState }: StateContext<LeadSearchFilter>,
        { payload }: EmitterAction<LeadSearchFilter>
    ) {
        setState(payload)
    }

    @Receiver()
    static reset(
        { setState }: StateContext<LeadSearchFilter>) {
        const newEntry = new LeadSearchFilter();
        newEntry.isAll = false;
        newEntry.statusId = 0;
        setState(newEntry);
    }

}
